import {
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  GridList,
  GridListTile,
  GridListTileBar,
  

} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AttachmentIcon from '@material-ui/icons/Attachment';
import MonochromePhotosIcon from '@material-ui/icons/MonochromePhotos';
import AlertYasal from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axiosCatalog';
import { loadFotograf } from 'src/utils/storage/StrPhoto';
import FilesPreview from './FilePreview';
import CamPopup from './CamPopup';
import CCFilePopup from './CCFilePopup';
import FilePopup from './FilePopup';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    width: 500,
    height: 450
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#1D3343'
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function Detay({
  className, readonly, ReceiptNo, tasks, ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [Loading, setLoading] = useState(true);
  const [openCam, setOpenCam] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [DosyaTipi, setDosyaTipi] = useState(1);
  const [DosyaIsmi, setDosyaIsmi] = useState('');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [files, setFiles] = useState([]);
  const [CCFilePopupOpen, setCCFilePopupOpen] = React.useState(false);

  const DosyaTipihandleChange = (event) => {
    // setDosyaIsmi(event.target.name);

    setDosyaTipi(event.target.value);
  };
  const handleFileText = (event) => {
    setDosyaIsmi(event.target.innerText);
  };

  const handleChangeDosyaIsmi = (event) => {
    const { value } = event.target;
    setDosyaIsmi(value);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleCamOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Dosya_sec_error')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setOpenCam(true);
  };
  const handleCamClose = (type) => {
    if (type === 'file') {
      setOpenFile(false);
    } else {
      setOpenCam(false);
    }
    setLoading(true);
    const localPhotos = loadFotograf(ReceiptNo);
    setFiles(localPhotos);
    axios
      .get(`/GetSiriusFileList/${ReceiptNo}`)
      .then((response) => {
        if (response.data === '') {
          setLoading(false);
          setFiles(localPhotos);
        } else {
          const Deger = response.data;
          setFiles([...Deger, ...localPhotos]);
          setLoading(false);
        }
      })
      .catch((error) => {
        setFiles(localPhotos);
        setLoading(false);
      });
  };
  const handleFileOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Dosya_sec_error')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setOpenFile(true);
  };
  const handleFileClose = (dataUri) => {
    handleCamClose('file');
  };
  const handleCCFileClose = () => {
    setCCFilePopupOpen(false);
  };
  const fetchPhotos = (mounted) => {
    setLoading(true);
    const localPhotos = loadFotograf(ReceiptNo);
    setFiles(localPhotos);
    axios
      .get(`/GetSiriusFileList/${ReceiptNo}`)
      .then((response) => {
        if (mounted) {
          if (response.data === '') {
            setFiles(localPhotos);
            setLoading(false);
          } else {
            const Deger = response.data;
            setFiles([...Deger, ...localPhotos]);
            setLoading(false);
          }
        }
      })
      .catch((error) => {
        setFiles(localPhotos);
        setLoading(false);
      });
  };
  const storeData = tasks.find(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  useEffect(() => {
    let mounted = true;
    // setLoading(true);
    fetchPhotos(mounted);
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
    }, [ReceiptNo]);
  return (
    <Card>
      <CardContent>
        {uyari ? (
          <Alert
            onClose={uyariKapat}
            open={uyari}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        ) : (
          <div />
        )}
        <Grid container spacing={1} justify="space-between">
          <Grid item xs={4} align="left">
            <IconButton aria-label="settings" onClick={handleCamOpen}>
              <AddAPhotoIcon color="primary" />
            </IconButton>
          </Grid>
          <Grid item xs={4} align="center">
            <IconButton
              aria-label="settings"
                // onClick={setCCFilePopupOpen(true)}
              onClick={() => setCCFilePopupOpen(true)}
            >
              <MonochromePhotosIcon color="secondary" />
            </IconButton>
          </Grid>
          <Grid item xs={4} align="right">
            <IconButton aria-label="settings" onClick={handleFileOpen}>
              <AttachmentIcon color="primary" />
            </IconButton>
          </Grid>
        </Grid>
        <FormControl variant="outlined" className={classes.formControl}>
          <TextField
            size="small"
            fullWidth
            native
            select
            variant="outlined"
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            label={t('DosyaTipi')}
            value={DosyaTipi}
            onChange={(event) => {
              DosyaTipihandleChange(event);
            }}
          >
            {
              /*
              <MenuItem key={0} value={0} onClick={handleFileText}>
                {t('PhotoType0')}
              </MenuItem>
              */
              }
            <MenuItem key={1} value={1} onClick={handleFileText}>
              {t('PhotoType1')}
            </MenuItem>
            <MenuItem key={2} value={2} onClick={handleFileText}>
              {t('PhotoType2')}
            </MenuItem>
            <MenuItem key={3} value={3} onClick={handleFileText}>
              {t('PhotoType3')}
            </MenuItem>
            <MenuItem key={4} value={4} onClick={handleFileText}>
              {t('PhotoType4')}
            </MenuItem>
            <MenuItem key={5} value={5} onClick={handleFileText}>
              {t('PhotoType5')}
            </MenuItem>
            <MenuItem key={6} value={6} onClick={handleFileText}>
              {t('PhotoType6')}
            </MenuItem>
            <MenuItem key={7} value={7} onClick={handleFileText}>
              {t('PhotoType7')}
            </MenuItem>
            <MenuItem key={8} value={8} onClick={handleFileText}>
              {t('PhotoType8')}
            </MenuItem>
            <MenuItem key={9} value={9} onClick={handleFileText}>
              {t('PhotoType9')}
            </MenuItem>
            <MenuItem key={10} value={10} onClick={handleFileText}>
              {t('PhotoType10')}
            </MenuItem>
            <MenuItem key={11} value={11} onClick={handleFileText}>
              {t('PhotoType11')}
            </MenuItem>
            <MenuItem key={12} value={12} onClick={handleFileText}>
              {t('PhotoType12')}
            </MenuItem>
            <MenuItem key={13} value={13} onClick={handleFileText}>
              {t('PhotoType13')}
            </MenuItem>
            <MenuItem key={14} value={14} onClick={handleFileText}>
              {t('PhotoType14')}
            </MenuItem>
            <MenuItem key={15} value={15} onClick={handleFileText}>
              {t('PhotoType15')}
            </MenuItem>
            <MenuItem key={16} value={16} onClick={handleFileText}>
              {t('PhotoType16')}
            </MenuItem>
            <MenuItem key={17} value={17} onClick={handleFileText}>
              {t('PhotoType17')}
            </MenuItem>
            <MenuItem key={18} value={18} onClick={handleFileText}>
              {t('PhotoType18')}
            </MenuItem>
            <MenuItem key={19} value={19} onClick={handleFileText}>
              {t('PhotoType19')}
            </MenuItem>
          </TextField>
        </FormControl>
        <br />
        <br />
        <TextField
          label={t('Dosya_ismi')}
          size="small"
          fullWidth
          name="DosyaIsmi"
          autoComplete="no"
          value={DosyaIsmi}
          onChange={handleChangeDosyaIsmi}
          variant="outlined"
        />
        <br />
        <br />
        <AlertYasal severity="warning">{t('yasal_uyari')}</AlertYasal>
      </CardContent>
      <Divider className={classes.divider} />
      <CardContent className={classes.content}>
        {Loading ? (
          <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
        ) : (
          <div />
        )}
        <FilesPreview
          ReceiptNo={ReceiptNo}
          files={files}
          fetchPhotos={fetchPhotos}
          setLoading={setLoading}
          WorkGuid={storeData.WorkOrderGuid}
        />
      </CardContent>

      <CamPopup
        onClose={handleCamClose}
        ReceiptNo={ReceiptNo}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        open={openCam}
      />
      <FilePopup
        onClose={handleFileClose}
        ReceiptNo={ReceiptNo}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        open={openFile}
      />
      <CCFilePopup
        onClose={handleCCFileClose}
        ReceiptNo={ReceiptNo}
        open={CCFilePopupOpen}
      />
    </Card>
  );
}

Detay.propTypes = {
  className: PropTypes.string
};

export default connect((state) => ({ tasks: state.workOrderDetail.WorkOrderInformation }))(Detay);
